import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../shared/utils/api';
import ROUTES from '../../shared/constants/routes';
import SubtopicRow from './SubtopicRow';
import SubtopicDetailPanel from './SubtopicDetailPanel';

export default function StudyUnitExpanded({
  studyUnitId,
  members,
  engineTopicById,
  selectedTopicId,
  onSelectTopic,
  onSaveTopic,
}) {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!studyUnitId) return;
    let cancelled = false;
    api(`/api/study-units/${studyUnitId}/practice-stats`).then(data => {
      if (cancelled || !data || data.error) return;
      setStats(data);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [studyUnitId]);

  const handlePracticeAll = () => {
    const firstId = members[0]?.id;
    if (firstId) navigate(`${ROUTES.QUESTIONS}?mode=topic&topic_id=${firstId}`);
  };

  // Collect visible providers: external sources + SQETrack (if it has data).
  const providers = [];
  const external = stats?.external_sources || {};
  Object.entries(external).forEach(([name, v]) => {
    if (v && v.questions > 0) {
      providers.push({ name, questions: v.questions, accuracy: v.accuracy_pct });
    }
  });
  const sqe = stats?.sqetrack;
  if (sqe && sqe.questions > 0) {
    providers.push({ name: 'SQETrack', questions: sqe.questions, accuracy: sqe.accuracy_pct });
  }

  return (
    <div className="tv3-su-expanded">
      {providers.length > 0 && (
        <div className="tv3-provider-stats">
          {providers.map((p, idx) => (
            <React.Fragment key={p.name}>
              {idx > 0 && <span className="tv3-provider-divider">·</span>}
              <span className="tv3-provider-chip">
                <span className="tv3-provider-chip-name">{p.name}</span>
                {p.accuracy != null ? `${Math.round(p.accuracy)}% on ${p.questions} Q${p.questions === 1 ? '' : 's'}` : `${p.questions} Q${p.questions === 1 ? '' : 's'}`}
              </span>
            </React.Fragment>
          ))}
        </div>
      )}

      <div className="tv3-practice-all-row">
        <span className="tv3-practice-all-text">
          {members.length} subtopic{members.length === 1 ? '' : 's'} in this study unit
        </span>
        <button className="tv3-btn-practice" onClick={handlePracticeAll}>Practice all</button>
      </div>

      {members.map(member => {
        const eng = engineTopicById?.[String(member.id)];
        const enriched = eng ? {
          ...member,
          engine_readiness: eng.readiness != null ? eng.readiness / 100 : undefined,
          engine_trend: eng.trend,
          engine_label: eng.primary_source_label,
        } : member;
        const displayTrend = eng?.trend === 'improving' ? 'up' : eng?.trend === 'declining' ? 'down' : member.trend_direction;
        return (
          <React.Fragment key={member.id}>
            <SubtopicRow
              topic={enriched}
              variant="l3"
              selected={selectedTopicId === member.id}
              trend={displayTrend}
              onClick={() => onSelectTopic(selectedTopicId === member.id ? null : member.id)}
            />
            {selectedTopicId === member.id && (
              <SubtopicDetailPanel topic={member} onSave={onSaveTopic} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
